import { render, staticRenderFns } from "./StaffGroupPage.vue?vue&type=template&id=a114c942&scoped=true&"
import script from "./StaffGroupPage.vue?vue&type=script&lang=js&"
export * from "./StaffGroupPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a114c942",
  null
  
)

export default component.exports